import { DataFetchingClient } from 'data-fetching-client';
export const pricingPageDataFetchingClient = new DataFetchingClient();